<template>
    <div>
        <div class="row form-group">
            <div class="col-4 text-right">พนักงาน</div>
            <div class="col-6">
                <multiselect
                    v-model="form.employee"
                    :options="optionEmployee"
                    select-label=""
                    deselectLabel=""
                    placeholder="เลือกพนักงาน"
                    :customLabel="employeeLabel"
                    track-by="id">
                </multiselect>
            </div>
        </div>
        <div class="row form-group">
            <div class="col-4 text-right">วันที่</div>
            <div class="col-6">
                <date-picker v-model="form.date"
                             placeholder="วันที่ได้ OT"
                             :format="changeFormat"
                             :lang="lang" confirm>
                </date-picker>
            </div>
        </div>
        <div class="row form-group">
            <div class="col-4 text-right">ชม.OT</div>
            <div class="col-6">
                <input type="number" class="form-control" v-model="form.hour"/>
            </div>
        </div>
        <div class="col">
            <div class="col text-center">
                <button type="button"
                        @click="confirmAddHour"
                        class="btn btn-success">
                    <icon name="save"></icon>
                    บันทึก</button>&nbsp;&nbsp;
                <button type="button"
                        @click="cancelAddHour"
                        class="btn btn-outline-secondary">
                    <icon name="times"></icon> ยกเลิก
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import Multiselect from "vue-multiselect"
    import DatePicker from 'vue2-datepicker'
    import moment from "moment";
    import {mapState} from "vuex";
    export default {
        name: "AddOtEmployeeModal",
        components:{Multiselect,DatePicker},
        data(){
          return{
              optionEmployee : [],
              changeFormat: {
                  stringify: (date) => {
                      let date_moment = moment(date).format('YYYY');
                      const year = parseInt(date_moment) + 543;
                      console.log(moment(date).format('DD/MM/'+year));
                      return date ? moment(date).format('DD/MM/'+year) : null
                  },
                  parse: (value) => {
                      return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                  }
              },
              lang: {
                  days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                  months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                  pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                  placeholder: {
                      date: 'วว/ดด/ปปปป',
                  }
              },
          }
        },
        computed:{
            ...mapState({
                form : state=>{
                    return state.ScanEmployee.form_import_ot
                }
            })
        },
        created() {
            this.getEmployeeAll();
        },
        methods:{
            employeeLabel(option){
                return `${option.employee_no} - ${option.name}`
            },
            confirmAddHour(){
                if(!this.form.employee){
                    alert("กรุณาเลือกพนักงาน");
                }else if(!this.form.date){
                    alert("กรุณาเลือกวันที่");
                }else if(!this.form.hour){
                    alert("กรุณาใส่ ชม. OT");
                }else{
                    let data = {
                        id : this.form.id,
                        employee_id : this.form.employee ? this.form.employee.id : '',
                        date : moment(this.form.date).format("YYYY-MM-DD"),
                        hour : this.form.hour,
                    }
                    this.$emit('submit',data)
                }
            },
            cancelAddHour(){
                this.$emit('submit',false)
            },
            getEmployeeAll(){
                this.$store.dispatch("Employee/getEmployeeAll").then(res=>{
                    this.optionEmployee = res;
                })
            },
        },
    }
</script>

<style scoped>

</style>
